#import "~/graphql/fragments/pageContent/postCardsContent.graphql"

fragment flexiblePostsFeaturedManualSelect on flexibleSections_postsFeaturedManualSelect_BlockType {
    __typename
    title: plaintext
    description: richTextMinimal
    posts: selectPosts {
       ...postCardsContent
    }
}
